import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import pluralize from 'pluralize';

import Responsive from 'src/components/responsive';
import InlineBanner, { bannerStyles } from 'src/components/inline-banner/InlineBanner';
import { useUnmatchedListings } from 'src/services/api/listings';
import { usePersistentState } from 'src/services/storage/use-persistent-state';

export default function UnmatchedListingAlert() {
    const { data } = useUnmatchedListings();
    const navigate = useNavigate();
    const [isDismissed, setIsDismissed] = usePersistentState('unmatchedListingAlertDismissed', false);
    const unmatchedListings = data?.unmatched ?? [];
    const unreadCount = unmatchedListings.filter((l) => l.notification_id != null).length;

    if (unreadCount === 0 || isDismissed) { return null; }

    const noun = pluralize('listing', unreadCount);
    const verb = unreadCount === 1 ? 'is' : 'are';

    return (
        <Responsive desktop>
            <InlineBanner
                severity="error"
                icon={<Link size={15} />}
                title="Unmatched Listings"
                description={`${unreadCount} ${noun} ${verb} not matched to a property.`}
                onDismiss={() => setIsDismissed(true)}
                actions={
                    <Button
                        variant="outlined"
                        size="small"
                        className={`${bannerStyles.actionBtn} ${bannerStyles.outlined}`}
                        onClick={() => navigate('/landlord/inner/properties/listings')}
                        data-testid="unmatched-listings-view-button"
                    >
                        View {noun}
                    </Button>
                }
            />
        </Responsive>
    );
}
